export const HERO_IMAGE =
  'https://cdn.magicpatterns.com/uploads/tFyzU1JGaRYgDhyARjE9ES/349.png'

export const HERO_IMAGE_WIDTH = 1080

export const HERO_IMAGE_HEIGHT = 1350

export const HERO_IMAGE_ALT =
  'Kit completo Tenis 360: caja del plan anual rodeada de los 6 bonos en PDF'
